export const sliceCarouselCards = <T>(cards: T[] | undefined, index: number): T[] | undefined => {
    if (!cards) return cards;

    const prevItem = cards[index - 1];
    const currentItem = cards[index];
    const nextItem = cards[index + 1];

    return [prevItem, currentItem, nextItem];
};

export const addCardholder = <T extends { status: string }>(cards: T[]): T[] => {
    if (!cards?.length) {
        cards.push({ status: 'N' } as T);
    }
    return cards;
};

export const changeDirection = (index: number, clockwise: boolean): number =>
    clockwise ? index + 1 : index - 1;

export const shouldChange = (cards: unknown[], index: number, clockwise: boolean): boolean => {
    const newIndex = clockwise ? index + 1 : index - 1;
    return !cards[newIndex];
};

export const maskedCardSerial = (cardSerial: string | null | undefined): string | null => {
    if (!cardSerial) return null;

    const maskedNumber = cardSerial.replace(/.(?=.{4})/g, '*');
    return maskedNumber.replace(/(.{6})/g, '$1 ');
};

export const formattedCardSerial = (cardSerial: string | null | undefined): string | null => {
    if (!cardSerial) return null;
    return cardSerial.replace(/(\d{6})(\d{4})/, '$1 $2');
};

export const maskedCardCVV = (cardCVV: string | null | undefined): string | null => {
    if (!cardCVV) return null;

    const maskedNumber = cardCVV.replace(/.(?=.{4})/g, '*');
    return maskedNumber.replace(/(.{6})/g, '$1 ');
};

export const formattedCardCVV = (cardCVV: string | null | undefined): string | null => {
    if (!cardCVV) return null;
    return cardCVV.replace(/(\d{6})(\d{4})/, '$1 $2');
};
